import { UserRepository } from '../contracts/repositories';
import { User } from '../entities';
import { SessionService } from './session.service';

export class UserService {
  constructor(private readonly userRepository: UserRepository) {}

  hasRole(role: string) {
    const storedRole = SessionService.getSession().role;
    if (!storedRole) return;
    return storedRole === role;
  }

  getUser(): User {
    return SessionService.getSession();
  }

  async create(user: User): Promise<void> {
    await this.userRepository.create(user);
  }
}
